module.exports = __webpack_public_path__ + "static/media/empathy.4a179825.png";